module.exports = __webpack_public_path__ + "img/logo-ars.b895624c.png";